import React, {Component} from 'react'
import {Card, Table, message, Spin} from 'antd'
import {decode} from 'utf8'
import {connect} from 'react-redux'
import './styles.css'

const columns = [
  {
    title: 'Código cupon',
    dataIndex: 'code',
    key: 'code',
    render: text => <span>{text}</span>,
  },
  {
    title: 'Nombre vendedor',
    dataIndex: 'vendorName',
    key: 'vendorName',
  },
  {
    title: 'Puntos redemidos',
    dataIndex: 'redeemedPoints',
    key: 'redeemedPoints',
  },
  {
    title: 'Fecha de compra',
    dataIndex: 'purchaseDate',
    key: 'purchaseDate',
  },
  {
    title: 'Fecha de canje',
    dataIndex: 'redemptionDate',
    key: 'redemptionDate',
  },
  {
    title: 'Estado',
    dataIndex: 'redemptionState',
    key: 'redemptionState',
  },
]

class TableBalanceCompany extends Component {
  render() {
    return (
      <div>
        <Table
          className="gx-table-responsive"
          columns={columns}
          dataSource={this.props.dataCompanies}
        />
        <div className="containerPoints">
          <p className="labelValue">
            Total puntos canjeados:{' '}
            <span className="value">{this.props.totalPointsRedeemed}</span>
          </p>
          <p className="labelValue">
            Total puntos comprados:{' '}
            <span className="value">{this.props.totalPointsNotRedeemed}</span>
          </p>
        </div>
      </div>
    )
  }
}

function mapStateToProps({companiesInfo}) {
  const {
    dataCompanies,
    totalPointsNotRedeemed,
    totalPointsRedeemed,
  } = companiesInfo

  const dataCompaniesFixed = dataCompanies.map(element => ({
    ...element,
    redemptionState: element.redemptionState == 2 ? 'Canjeado' : 'Comprado',
  }))

  return {
    dataCompanies: dataCompaniesFixed,
    totalPointsNotRedeemed,
    totalPointsRedeemed,
  }
}
export default connect(mapStateToProps)(TableBalanceCompany)



// WEBPACK FOOTER //
// ./src/routes/main/Reports/balanceCompany/TableBalanceCompany.js